module.exports = __webpack_public_path__ + "static/img/introduceBTypeBIcon5.82b1786.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/introduceBTypeBIcon5.png
// module id = ODig
// module chunks = 0